export default __webpack_public_path__ + "static/media/atdeathsdoor.85cf6892.png";